import React from 'react';
import './App.css'; // Import CSS for styling

function Banner() {
  const bannerText = "Veja nosso relatório sobre a regulação de cripto no Brasil:";
  const linkText = "CLIQUE AQUI";
  const linkUrl = "https://docsend.com/view/z8ujs84g88iv477q";
  const updateText = "atualizado em : 25/4/25";
  const attributionText = "feito pela ";
  const paradigmaUrl = "http://twitter.com/paradigmaedu";

  // Create single content unit
  const contentUnit = (
    <>
      <span>{bannerText}</span>
      <a href={linkUrl} target="_blank" rel="noopener noreferrer">
        {linkText}
      </a>
      <span style={{ margin: '0 20px' }}></span>
      <span>{updateText}</span>
      <span style={{ margin: '0 20px' }}></span>
      <span>{attributionText}</span>
      <a href={paradigmaUrl} target="_blank" rel="noopener noreferrer">
        Paradigma
      </a>
      <span style={{ margin: '0 50px' }}></span> {/* Spacer between units */}
    </>
  );

  // Create enough copies to ensure no gaps
  return (
    <div className="banner-container">
      <div className="banner-content">
        {[...Array(6)].map((_, index) => (
          <React.Fragment key={index}>
            {contentUnit}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}

export default Banner; 